import React from 'react'
import { Alert } from '@lmc/ui-kit'
import {
  MentalCapacityToConsentSchema,
  type MentalCapacityToConsent,
} from '@lmc/validations'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import RadioGroup from './RadioGroup'

type PropTypes = {
  name: string
  value: boolean | undefined
  mentalCapacityStatus?: MentalCapacityToConsent
  onComplete: (update: boolean) => void
}

export const CapacityForm = ({
  name,
  onComplete,
  value,
  mentalCapacityStatus,
}: PropTypes) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
  <div className="signature-modal-vertial-center">
    <div>
      <p
        style={{
          transition: 'all 0.2s',
          fontWeight: 700,
          fontSize: 16,
        }}
      >
        {t(supConstants.MENTAL_CAPACITY_CONSENT_QUESTION, {
          variable: name,
        })}
      </p>
      {mentalCapacityStatus === MentalCapacityToConsentSchema.enum.yes && (
        <Alert
          type="success"
          message={t(supConstants.MENTAL_CAPACITY_HAS_CAPACITY)}
          showIcon
        />
      )}
      {mentalCapacityStatus === MentalCapacityToConsentSchema.enum.no && (
        <Alert
          type="error"
          message={t(supConstants.MENTAL_CAPACITY_NO_CAPACITY)}
          showIcon
        />
      )}
      {mentalCapacityStatus === MentalCapacityToConsentSchema.enum.in_progress && (
        <Alert
          type="info"
          message={t(supConstants.MENTAL_CAPACITY_IN_PROGRESS)}
          showIcon
        />
      )}
      <RadioGroup
        // @ts-ignore
        onChange={onComplete}
        value={value}
        options={[
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ]}
      />
    </div>
  </div>
  )
}

export default CapacityForm
